import styled from 'styled-components';

export const ContainerIcons = styled.div`
  svg:not(:first-child) {
    margin-left: 5px;
  }
`;